import { Dashboard } from '@/views';
import store from '@/store';
import serializeObj from '@/utils/serializeObj';
import Conpass from '@/services/Conpass';

export default [
  {
    name: 'dashboard',
    path: '/',
    component: Dashboard,
    async beforeEnter(to, from, next) {
      if (to.query.newUser) {
        Conpass.preLoad();
        await store.dispatch('dashboard/toggleWelcome', true);
        const { newUser, ...query } = to.query;
        const newTo = {
          ...to,
          query,
        };
        return next(newTo);
      }
      return next();
    },
  },
  {
    name: 'login',
    path: '/login',
    meta: {
      public: true,
    },
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/login';
    },
  },
  {
    name: 'accountSwitch',
    path: '/accountSwitch',
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/trocarconta';
    },
  },
  {
    name: 'logout',
    path: '/logout',
    meta: {
      public: true,
    },
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/logout';
    },
  },
  {
    name: 'treatments',
    path: '/treatments',
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/atendimento/home';
    },
  },
  {
    name: 'treatment',
    path: '/treatments/:treatmentId',
    beforeEnter(route) {
      const { treatmentId } = route.params;
      location.href = `${process.env.VUE_APP_LEGACY_APP_URL}/atendimento/form/${treatmentId}`;
    },
  },
  {
    name: 'call',
    path: '/call/:treatmentId/:callId',
    beforeEnter(route) {
      const { treatmentId, callId } = route.params;
      location.href = `${process.env.VUE_APP_LEGACY_APP_URL}/atendimento/form/${treatmentId}/chamada/${callId}`;
    },
  },
  {
    name: 'patientHistory',
    path: '/patientHistory/:historyToken',
    beforeEnter(route) {
      const { historyToken } = route.params;
      location.href = `${process.env.VUE_APP_LEGACY_APP_URL}/paciente/timeline/${historyToken}`;
    },
  },
  {
    name: 'patients',
    path: '/patients',
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/paciente/buscar';
    },
  },
  {
    name: 'patient-register',
    path: '/patient-register',
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/paciente/form';
    },
  },
  {
    name: 'finances',
    path: '/finances',
    beforeEnter() {
      location.href =
        process.env.VUE_APP_LEGACY_APP_URL + '/financeiro/meu-extrato';
    },
  },
  {
    name: 'my-schedules',
    path: '/my-schedules',
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/horarios';
    },
  },
  {
    name: 'my-data',
    path: '/my-data',
    beforeEnter() {
      location.href =
        process.env.VUE_APP_LEGACY_APP_URL + '/especialista/meusdados';
    },
  },
  {
    name: 'change-password',
    path: '/change-password',
    beforeEnter() {
      location.href = process.env.VUE_APP_LEGACY_APP_URL + '/alterar-senha';
    },
  },
  {
    name: 'manual',
    path: '/manual',
    beforeEnter() {
      location.href =
        'https://materiais.conexasaude.com.br/entendendo-sobre-a-plataforma';
    },
  },
  {
    name: 'config',
    path: '/config',
    meta: { public: true },
    beforeEnter({ query }) {
      const serialized = serializeObj(query),
        { VUE_APP_CONFIG_APP_URL } = process.env;

      location.href = `${VUE_APP_CONFIG_APP_URL}${
        serialized ? `?${serialized}` : ''
      }`;
    },
  },
  {
    path: '*',
    redirect: '/',
  },
];
